import { Component, EventEmitter, h, State, Event, Prop } from '@stencil/core';

@Component({
  tag: 'generic-form',
  styleUrl: 'generic-form.css',
  shadow: true
})
export class GenericForm {
  @State() formData: { [key: string]: any } = {};
  @Event() formSubmit: EventEmitter<any>;
  @Prop() config: any;
  @State() resetKey: number = 0; // Add this line
  // private handleChange = (e: Event, field: any) => {
  //   const target = e.target as HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;
  //   let value: any = target.value;

  //   if (field.type === 'checkbox') {
  //     value = (target as HTMLInputElement).checked;
  //   }
  //   if (field.type === 'file') {
  //     value = (target as HTMLInputElement).files;
  //   }
  //   if (field.type === 'select' && field.allow_multi_selection) {
  //     value = Array.from((target as HTMLSelectElement).selectedOptions).map(opt => opt.value);
  //   }
  //   this.formData = { ...this.formData, [field.id]: value };
  // };

  getFormData(e) {
    e.preventDefault();
    const formData = this.formData;
    console.log('Form Data from stencil:', formData);
    this.formSubmit.emit(formData);
  }

   private handleValueChanged = (event: CustomEvent<{ id: string; value: any }>) => {
    this.formData = {
      ...this.formData,
      [event?.detail?.id]: event?.detail?.value
    };
  };

  private resetForm = () => {
  this.formData = {};
  this.resetKey++; // This triggers a re-render and notifies children
};


  private renderField(field: any) {
    // const commonProps = {
    //   id: field.id,
    //   name: field.id,
    //   required: field.required,
    //   placeholder: field.placeholder,
    //   pattern: field.pattern || undefined,
    //   value: this.formData[field.id] ?? field.value ?? field.default ?? '',
    //   onInput: (e: Event) => this.handleChange(e, field),
    //   onChange: (e: Event) => this.handleChange(e, field)
    // };

    switch (field.type) {
      case 'text':
      case 'email':
      case 'password':
      case 'number':
      case 'date':
      case 'time':
      case 'url':
      case 'range':
      case 'month':
      case 'week':
      case 'search':
      case 'tel':
        return (
          <form-input resetKey={this.resetKey} inputValue={field} onValueChanged={this.handleValueChanged}></form-input>
        );
      case 'textarea':
        return (
          <form-textarea inputValue={field} onValueChanged={this.handleValueChanged}></form-textarea>
        );
      case 'select':
        return (
           <form-select  resetKey={this.resetKey}  inputValue={field} onValueChanged={this.handleValueChanged}></form-select>
        );
      case 'checkbox':
        return (
          <form-checkbox inputValue={field} onValueChanged={this.handleValueChanged}></form-checkbox>
        );
      case 'radio':
        return (
          <form-radio inputValue={field} ></form-radio>
        );
      case 'file':
        return (
          <form-upload inputValue={field} onValueChanged={this.handleValueChanged}></form-upload>
        );
        case 'cancel':
          return (
            <form-button inputValue={field} onButtonClick={this.resetForm}></form-button>
        );
        case 'submit':
          return (
          // <div>
          //   <ix-button class="place-button" type="submit" onClick={this.getFormData.bind(this)}>{field.value || field.label}</ix-button>
          // </div>
          <form-button inputValue={field} onButtonClick={this.getFormData.bind(this)}></form-button>
        );
      default:
        return null;
    }
  }

  private handleSubmit = (e: Event) => {
    e.preventDefault();
    // You can handle form submission here
    // For demo, just log the formData
    console.log('Form Data:', this.formData);
  };

  render() {
    return (
      <form class='gen-form' onSubmit={this.handleSubmit}>
        {this.config.map(field => (
          <div 
            key={field.id} 
            style={{ marginBottom: '1em' }} 
            class={field.type === 'submit' || field.type === 'cancel' ? 'action-box' : ''}> 
            { this.renderField(field)}
          </div>
        ))}
      </form>
    );
  }
}